import { filterUniqueAssignments } from "./1_DeadlineHelpers/4_Functions/filterUniqueAssignments";
import { filterTasksByCourse } from "./1_DeadlineHelpers/filterTasksByCourse";
import { sortTasksByDueDateAndPriority } from "./1_DeadlineHelpers/sortTasksByDueDateAndPriority";

export const calculateClassDeadlineAssignments = async (
  relevantAssignments,
  setClassDeadlineAssignments,
  selectedCourse,
  showCourseAssignmentOnly,
) => {
  if (relevantAssignments?.thisWeek?.length > 0) {
    let filteredAssignments = await filterUniqueAssignments(
      //returns one assignment and calculates an average
      relevantAssignments.thisWeek,
      "assignment_id",
    );
    // console.log(filteredAssignments)
    if (selectedCourse) {
      filteredAssignments = filteredAssignments.filter(
        (assignments) =>
          assignments.core_course_id === selectedCourse.core_course_id,
      );
    }

    if (showCourseAssignmentOnly) {
      filteredAssignments = await filterTasksByCourse(
        selectedCourse,
        filteredAssignments,
      );
    }

    const sortedAssignments =
      await sortTasksByDueDateAndPriority(filteredAssignments);
    // console.log(sortedAssignments)
    await setClassDeadlineAssignments(sortedAssignments);
  } else {
    await setClassDeadlineAssignments([]);
  }
};
